// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_3EdHVAmtG-ArRoPsMODKG0_0","header":"PUiofADk28YgUqknj448Q_0","card-box":"_2iTJYEtT6axZF2h5BzsWh5_0","active":"Yaty6nlaFNr9W_EDuc6xz_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ced4132","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/game-states/VOTING/index.vue
// module id = 210
// module chunks = 0